export type HalvingBoltConfiguratorSearch = {
    seed: string;
    /** The halving tiers in timeline order, comma-separated, for example "50,100,150". */
    halvings: string;
    zwennies: number;
    /** Runs the drift path of the slideshow instead of the static path of the presenter view. */
    animated: boolean;
};

/**
 * Parses the search params of the halving bolt configurator.
 *
 * Rule: this file has no import. The route config imports it outside the code-split component chunk, so any import
 * ships in the main bundle.
 */
export const parseHalvingBoltConfiguratorSearch = (search: Record<string, unknown>): HalvingBoltConfiguratorSearch => ({
    seed: search.seed !== undefined ? String(search.seed) : "zwennie",
    halvings: search.halvings !== undefined ? String(search.halvings) : "50,100,150",
    zwennies: typeof search.zwennies === "number" ? search.zwennies : 25,
    animated: search.animated === true,
});
